import React from "react";

import { StoryBlock } from "~components/shared/story-block/StoryBlock";
import type { CuratedItem } from "~types/types";

import styles from "./TertiaryItems.module.css";

const DEFAULT_STARTING_INDEX = 4;
const DEFAULT_MAX_ITEMS = 3;

export default function TertiaryItems({
    items = [],
    startingIndex = DEFAULT_STARTING_INDEX,
    maxItems = DEFAULT_MAX_ITEMS,
}: {
    items: CuratedItem[];
    startingIndex?: number;
    maxItems?: number;
}) {
    if (!items.length) return null;

    return (
        <div className={styles.TertiaryItems} data-component="tertiary-items">
            <div className={styles.container}>
                {items.slice(0, maxItems).map((item, index) => (
                    <div className={styles.item} key={item.url}>
                        <StoryBlock
                            story={item}
                            isSecondaryStory
                            withDek
                            storyIndex={index + startingIndex}
                            disableFeaturedStyling
                            isExtraSmallHeadline
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
